import RoomStore from './RoomStore';
import UploadStore from './UploadStore';

export interface BaseStoreTypes {
    RoomStore: RoomStore;
    UploadStore: UploadStore;
    Room:  RoomStore;
}

export interface BaseStoreProps {
  BaseStore: BaseStoreTypes
}

const BaseStore = {
    RoomStore: new RoomStore(),
    UploadStore: new UploadStore(),
    Room: new RoomStore()
}

export default BaseStore;
